"use client"

import { withStyles } from "@mui/styles"
import React, { Component } from "react"
import { injectIntl } from "react-intl"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Styles } from "src/styles/material-styles"
import PropTypes from "prop-types"
import { AbilityContext } from "src/config/ability-context"
import Api from "src/services/api"
import Header from "src/components/header-external"
import { PapiroConsole } from "src/utils/papiroConsole"
import CustomizedSnackbars from "src/components/material-snackbars"
import LogoMarca from "src/images/new-logo2-cmtech.png"
import Footer from "src/components/footer-external"
import * as articleActions from 'src/redux/actions/articles';
import {
    Box,
} from "@mui/material"
import {
    PictureAsPdf,
    Description,
    Image,
    VideoFile,
    AudioFile,
    AttachFile,
} from "@mui/icons-material"
import { getFileDownloadLink } from "../../services/attachment.service"
import Modal from "src/components/modal-external/modal-principal";
import CalledServicesSettingsExternalFormList from "../client-portal-external/components/called-services-settings-external-form-list";
import CommonPaginateSkeleton from "src/components/client-portal/common-paginate-skeleton"
import CommonSearchExternal from "src/components/client-portal/common-search-external"
import FAQExternalClientMainContent from "src/components/faq-external-client-components/faq-external-client-main-content"

const TAG_COLOR_PALETTE = [
    {
        name: "blue",
        backgroundColor: "#eff6ff",
        color: "#1e40af",
        border: "#dbeafe",
    },
    {
        name: "emerald",
        backgroundColor: "#ecfdf5",
        color: "#059669",
        border: "#d1fae5",
    },
    {
        name: "amber",
        backgroundColor: "#fffbeb",
        color: "#d97706",
        border: "#fed7aa",
    },
    {
        name: "rose",
        backgroundColor: "#fff1f2",
        color: "#e11d48",
        border: "#fecdd3",
    },
    {
        name: "violet",
        backgroundColor: "#f5f3ff",
        color: "#7c3aed",
        border: "#ddd6fe",
    },
    {
        name: "cyan",
        backgroundColor: "#ecfeff",
        color: "#0891b2",
        border: "#cffafe",
    },
    {
        name: "orange",
        backgroundColor: "#fff7ed",
        color: "#ea580c",
        border: "#fed7aa",
    },
    {
        name: "teal",
        backgroundColor: "#f0fdfa",
        color: "#0d9488",
        border: "#ccfbf1",
    },
]
class AttachmentIcon extends Component {
    getFileExtension(filename) {
        return filename.split(".").pop().toLowerCase()
    }

    getIconByExtension(extension) {
        switch (extension) {
            case "pdf":
                return <PictureAsPdf sx={{ color: "#dc2626" }} />
            case "doc":
            case "docx":
                return <Description sx={{ color: "#2563eb" }} />
            case "xls":
            case "xlsx":
                return <Description sx={{ color: "#059669" }} />
            case "jpg":
            case "jpeg":
            case "png":
            case "gif":
            case "bmp":
            case "svg":
                return <Image sx={{ color: "#059669" }} />
            case "mp4":
            case "avi":
            case "mov":
            case "wmv":
            case "flv":
                return <VideoFile sx={{ color: "#7c3aed" }} />
            case "mp3":
            case "wav":
            case "flac":
            case "aac":
                return <AudioFile sx={{ color: "#ea580c" }} />
            default:
                return <AttachFile sx={{ color: "#6b7280" }} />
        }
    }

    render() {
        const { filename } = this.props
        const extension = this.getFileExtension(filename)
        return this.getIconByExtension(extension)
    }
}
class FaqExternal extends Component {
    constructor(props) {
        super(props)
        const generalSearchFaqId = localStorage.getItem("generalSearchFaqId")
        localStorage.removeItem("generalSearchFaqId")
        this.state = {
            clientportal: {},
            loading: false, // loading global
            loadingFaqs: false, // loading apenas para getFaqs
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            createCalledDialogOpen: false,

            selectedFaq: null,

            appName: Api != null ? Api.getAppName() : "CMTECH - Mexx 2DO",
            logoimagesrc: "",
            mainimagesrc: "",
            faqs: [],
            filteredFaqs: [],
            subjectList: [],
            selectedSubject: "all",
            sortBy: "date",
            sortOrder: "desc",
            expandedFaqs: [], // Alterado para array
            highlightedFaqId: null,
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,

            searchValue: "",
            searchValueList: [],

            selectedSubject: "all",
            selectedSubjectList: [],

            searchValueBar: "",
            hirerid: null,
            defaultExpanded: generalSearchFaqId ?? 0,
        }

        this.contentRef = React.createRef()
        this.topRef = React.createRef();

        this.pageInitialize = this.pageInitialize.bind(this)
        this.goToScrollTop = this.goToScrollTop.bind(this)

        this.handleChange = this.handleChange.bind(this)
        this.openCreateCalledDialog = this.openCreateCalledDialog.bind(this)
        this.closeNotification = this.closeNotification.bind(this)
        this.searchArticle = this.searchArticle.bind(this)

        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.getFaqs = this.getFaqs.bind(this)
        this.clearFaqs = this.clearFaqs.bind(this)
        this.handleAttachmentClick = this.handleAttachmentClick.bind(this)
        this.getTagVariant = this.getTagVariant.bind(this)
        this.checkForFaqId = this.checkForFaqId.bind(this)

        this.addFilter = this.addFilter.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
        this.handleDelete = this.handleDelete.bind(this)

        // this.filterFaqs = this.filterFaqs.bind(this)

        this.handleClickOpenSubjectToFaqs = this.handleClickOpenSubjectToFaqs.bind(this)

        this.formattedGroupFaqsFromSubject = this.formattedGroupFaqsFromSubject.bind(this)

        this.handleSelectedFaq = this.handleSelectedFaq.bind(this)

    }

    useStyles = () => {
        return withStyles({
            ImageList: {
                width: "100%",
                height: 100,
            },
        })
    }

    async componentDidMount() {
        this.setState({ loading: true })

        const hirerid = await this.getHirerId()

        if (hirerid) {
            await this.getClientPortal(hirerid)
            await this.getSubjects(hirerid)

            const urlParams = new URLSearchParams(window.location.search)
            const faqId = urlParams.get("id")

            await this.getFaqs(1, faqId)
        }

        // Scroll para o FAQ destacado após o carregamento
        this.checkForFaqId()

        this.pageInitialize();

        this.setState({ loading: false })
    }

    pageInitialize = () => {
        document.title = this.state.appName
    }

    goToScrollTop = () => {
        if (this.topRef.current) {
            this.topRef.current.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    // async componentDidMount() {
    //     document.title = this.state.appName
    //     this.setState({ loading: true })
    //     const hirerid = await this.getHirerId()

    //     PapiroConsole.log("hirerid")
    //     PapiroConsole.log(hirerid)

    //     if (hirerid) {
    //         await this.getClientPortal()
    //         await this.getSubjects(hirerid)
    //         await this.getFaqs(hirerid)
    //     }
    //     // await this.getClientPortal()
    //     // await this.getSubjects()
    //     // await this.getFaqs()
    //     this.checkForFaqId()

    // }

    checkForFaqId() {
        const urlParams = new URLSearchParams(window.location.search)
        const faqId = urlParams.get("id")
        if (faqId) {
            this.setState((prevState) => ({
                highlightedFaqId: Number.parseInt(faqId),
                expandedFaqs: [...prevState.expandedFaqs, Number.parseInt(faqId)],
            }))
            setTimeout(() => {
                const element = document.getElementById(`faq-${faqId}`)
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "center" })
                }
            }, 500)
        }
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getFaqs(page);
    };

    setPagination(count, page) {
        let totalPage = Math.ceil(count / 10);
        this.setState({ totalPages: totalPage });
        if (count > 0) {
            if (page == 1) {
                if (count < 10) {
                    this.setState({ pageStart: 1, pageEnd: count });
                } else {
                    this.setState({ pageStart: 1, pageEnd: 10 });
                }
            } else {
                let pageStart = (page - 1) * 10 + 1;

                if (count >= page * 10) {
                    this.setState({ pageStart: pageStart, pageEnd: page * 10 });
                } else {
                    this.setState({ pageStart: pageStart, pageEnd: count });
                }
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 });
        }
    }

    getTagColor = (tagName) => {
        // Cria um hash simples baseado no nome da tag
        let hash = 0
        for (let i = 0; i < tagName.length; i++) {
            const char = tagName.charCodeAt(i)
            hash = (hash << 5) - hash + char
            hash = hash & hash // Converte para 32bit integer
        }

        // Usa o hash para selecionar uma cor da paleta
        const colorIndex = Math.abs(hash) % TAG_COLOR_PALETTE.length
        return TAG_COLOR_PALETTE[colorIndex]
    }


    async getSubjects(hirerid) {
        this.setState({ loading: true })

        const url = `faq-subject/get-subjects?hirerid=${hirerid}`

        var result = await Api.get(url)
            .then((rs) => rs.data)
            .catch((err) => err)

        if (result.success) {
            this.setState({ subjectList: result.data })
        } else {
            const intl = this.props.intl
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    result.data &&
                        result.data.response &&
                        result.data.response.data &&
                        result.data.response.data.errors &&
                        result.data.response.data.errors[0]
                        ? result.data.response.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }),
            })
            Api.kickoff(result)
        }
    }

    // filterFaqs() {
    //     const { faqs, selectedSubject, searchValue, sortBy, sortOrder } = this.state
    //     let filtered = [...faqs]

    //     // Filtrar por assunto
    //     if (selectedSubject !== "all") {
    //         filtered = filtered.filter((faq) => faq.subject.id.toString() === selectedSubject)
    //     }

    //     // Filtrar por busca
    //     if (searchValue && searchValue.trim()) {
    //         filtered = filtered.filter(
    //             (faq) =>
    //                 faq.question.toLowerCase().includes(searchValue.toLowerCase()) ||
    //                 faq.answer.toLowerCase().includes(searchValue.toLowerCase()) ||
    //                 (faq.faqtags && faq.faqtags.some((tag) => tag.tagname.toLowerCase().includes(searchValue.toLowerCase()))),
    //         )
    //     }

    //     // Ordenação
    //     filtered.sort((a, b) => {
    //         let comparison = 0

    //         if (sortBy === "date") {
    //             const dateA = new Date(a.createdat || a.id)
    //             const dateB = new Date(b.createdat || b.id)
    //             comparison = dateA - dateB
    //         } else if (sortBy === "name") {
    //             comparison = a.question.localeCompare(b.question)
    //         }

    //         return sortOrder === "asc" ? comparison : -comparison
    //     })

    //     this.setState({ filteredFaqs: filtered })
    // }

    getTagVariant() {
        const variants = ["primary", "secondary", "warning", "info"]
        const randomIndex = Math.floor(Math.random() * variants.length)
        return variants[randomIndex]
    }

    async handleSearchChange(event, stateName) {
        if (stateName === "tag") {
            const hasThisTagInSearchValueList =
                this.state.searchValueList.some(search => search.trim() == event.trim());

            if (hasThisTagInSearchValueList) {
                return this.goToScrollTop();
            }

            await this.setState({ searchValue: event }, async () => {
                await this.handleSearch();

                this.goToScrollTop();
            })

            return;
        }

        if (stateName === "sortBy") {
            this.setState({ sortBy: event.target.value });

            return;
        }

        if (stateName === "sortOrder") {
            this.setState({ sortOrder: event.target.value });

            return;
        }

        if (stateName === "selectedSubject") {
            const value = event.target.value;
            // Captura o id do assunto selecionado
            const selectedId = value === "all" ? "all" : Number(value);
            this.setState({ selectedSubject: selectedId });

            return;
        }

        this.setState({ searchValue: event.target.value })
    }


    handleAttachmentClick(attachment) {
        PapiroConsole.log("Abrindo anexo:", attachment)
    }

    handleClickOpenSubjectToFaqs(subjectId) {
        const { filteredFaqs } = this.state;

        let helpNewFilteredFaqs = [...filteredFaqs];

        const getSubject = helpNewFilteredFaqs.findIndex(a => a.subjectId === subjectId);

        helpNewFilteredFaqs[getSubject].open = !helpNewFilteredFaqs[getSubject].open;

        this.setState({
            filteredFaqs: helpNewFilteredFaqs
        });
    };

    getHirerId = async () => {
        const intl = this.props.intl;

        return await Api.get(`/configs/cancreateclientusersexternal`)
            .then((result) => {
                if (result.data.success) {
                    if (result.data.data != null) {
                        if (result.data.data.hirerid != null && result.data.data.hirerid > 0) {
                            this.setState({ hirerid: result.data.data.hirerid })
                            return result.data.data.hirerid
                        } else {
                            var l = this.props.match.params.lang
                            document.location.href = `/${l}/unavailable`
                            return null
                        }
                    }
                } else {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data &&
                                result.data.response &&
                                result.data.response.data &&
                                result.data.response.data.errors &&
                                result.data.response.data.errors[0]
                                ? result.data.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    })
                    Api.kickoff(result)
                    return null
                }
            })
            .catch((err) => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response && err.response.data && err.response.data.errors && err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                })
                Api.kickoff(err)
                return null
            })
    }

    async addFilter() {
        let newSearchValueList = [...this.state.searchValueList];
        let newSelectedSubjectList = [...this.state.selectedSubjectList];

        if (this.state.searchValue != '') {
            const hasSearchValue = newSearchValueList.some(search => search.trim() === this.state.searchValue.trim());
            if (!hasSearchValue) {
                newSearchValueList = [...newSearchValueList, this.state.searchValue];
            }
        }

        if (!!this.state.selectedSubject && this.state.selectedSubject !== "all") {
            const hasSubjectSelected = newSelectedSubjectList.some(subjectId => subjectId === this.state.selectedSubject);
            if (!hasSubjectSelected) {
                newSelectedSubjectList = [...newSelectedSubjectList, this.state.selectedSubject];
            }
        }

        this.setState({
            searchValue: '',
            selectedSubject: 'all',
            searchValueList: newSearchValueList,
            selectedSubjectList: newSelectedSubjectList,
        })

    }

    async handleDelete(chipToDelete, type) {
        const allFilters = [...this.state.searchValueList, ...this.state.selectedSubjectList];
        const isLastFilter = allFilters.length === 1;

        if (type === "search") {
            const newSearchValueList = this.state.searchValueList.filter((_, index) => index !== chipToDelete);

            await this.setState({ searchValueList: newSearchValueList });
        } else if (type === "subject") {
            const newSelectedSubjectList = this.state.selectedSubjectList.filter((_, index) => index !== chipToDelete);

            await this.setState({ selectedSubjectList: newSelectedSubjectList });
        }

        if (isLastFilter) {
            await this.handleSearch();
        }
    };

    async handleSearch() {
        await this.addFilter();

        await this.getFaqs(1);
    }

    async clearFaqs() {
        await this.setState({
            loadingFaqs: true,
            faqs: [],
            filteredFaqs: [],

            selectedFaq: null,

            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,

            searchValueList: [],
            selectedSubjectList: [],
            searchValue: "",
            selectedSubject: "all",
            sortBy: "date",
            sortOrder: "desc",
        })

        await this.getFaqs(1);
    }

    async getFaqs(page = 1, faqId) {
        if (!this.state.loadingFaqs) this.setState({ loadingFaqs: true });

        const { searchValueList, selectedSubjectList, sortBy, sortOrder } = this.state

        const params = new URLSearchParams()
        params.append("page", page)
        params.append("hirerId", this.state.hirerid)

        if (selectedSubjectList && selectedSubjectList.length > 0) {
            params.append("subjectid", selectedSubjectList.map(subjectId => subjectId.toString()).join(","))
        }
        if (searchValueList && searchValueList.length > 0) {
            params.append("search", searchValueList.join(","))
        }
        if (faqId) {
            params.append("faqid", faqId)
        }

        PapiroConsole.log("sortBy")
        PapiroConsole.log(sortBy)
        PapiroConsole.log("sortOrder")
        PapiroConsole.log(sortOrder)

        params.append("sortBy", sortBy)
        params.append("sortOrder", sortOrder)

        const queryString = params.toString()
        const url = `faq/paginate-external${queryString ? `?${queryString}` : ""}`

        Api.get(url)
            .then((result) => {

                if (result.data.success) {
                    PapiroConsole.log("result aqui")
                    PapiroConsole.log(result)

                    var faqs = result && result.data && result.data.data ? result.data.data : [];
                    let count = result.data.count;

                    const { list: formattedFaqs, first: firstFaq } = this.formattedGroupFaqsFromSubject(faqs);

                    this.setPagination(count, page);
                    this.setState({
                        faqs: faqs,
                        count: count,
                        filteredFaqs: formattedFaqs || [],
                        selectedFaq: firstFaq || null,
                        loadingFaqs: false
                    });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loadingFaqs: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data &&
                                result.data.response &&
                                result.data.response.data &&
                                result.data.response.data.errors &&
                                result.data.response.data.errors[0]
                                ? result.data.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    Api.kickoff(result);
                }
            })
            .catch((err) => {
                const intl = this.props.intl;
                this.setState({
                    loadingFaqs: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response &&
                            err.response.data &&
                            err.response.data.errors &&
                            err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(err);
            });
    }

    formattedGroupFaqsFromSubject(list) {
        const urlParams = new URLSearchParams(window.location.search)
        const faqIdFromParam = urlParams.get("id")
        const faqId = faqIdFromParam ? Number.parseInt(faqIdFromParam) : null;

        const firstFaq = list && list.length > 0 ? list[0] : null;
        const firstFaqId = firstFaq ? firstFaq.id : null;

        const currentFaqId = faqId ? faqId : firstFaqId;

        let data = [];
        if ((list && list.length <= 0) || !currentFaqId) return data;

        list.forEach((faq) => {
            const subject = faq.subject ? faq.subject : null;

            let subjectData = {
                ...faq,
                subjectId: subject ? subject.id : `subject-${faq.id}`,
                open: false,
                subjectName: subject ? subject.name : faq.question,
                mapGroudFaqFromSubject: [],
            };

            data.push(subjectData);
        });

        list.forEach(faq => {
            const subjectFromFaq = data.find(s => s.subjectId === faq.subject.id);

            const isActiveSubjectToFirstFaq = subjectFromFaq.id === parseInt(currentFaqId);

            if (subjectFromFaq) {
                subjectFromFaq.open = isActiveSubjectToFirstFaq ? true : subjectFromFaq.open;
                subjectFromFaq.mapGroudFaqFromSubject.push(faq);
            }
        });

        const _data = data.filter(subject => subject && subject?.mapGroudFaqFromSubject?.length > 0);
        return { list: _data, first: list[0] };
    }

    async getClientPortal(hirerid) {
        const intl = this.props.intl

        await Api.get(`/clientportal/external/hirer/${hirerid}`)
            .then((result) => {
                if (result.data && result.data.success) {
                    const data = result.data.data;
                    this.setState({
                        clientportal: data,
                    })
                    if (data.logoimage) {
                        this.getImageFile(data.logoimage, "logoimagesrc")
                    } else {
                        const image = Api.getLoginImage()
                        if (image) {
                            this.getImageFile(image, "logoimagesrc")
                        } else {
                            this.setState({ logoimagesrc: LogoMarca })
                        }
                    }
                    if (data.mainimage) {
                        this.getImageFile(data.mainimage, 'mainimagesrc')
                    }
                } else {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data &&
                                result.data.response &&
                                result.data.response.data &&
                                result.data.response.data.errors &&
                                result.data.response.data.errors[0]
                                ? result.data.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch((err) => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response && err.response.data && err.response.data.errors && err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                })
                Api.kickoff(err)
            })
    }

    getImageFile = async (image, stateKey) => {
        const xhttpImage = new XMLHttpRequest()
        xhttpImage.open("GET", `${image.anonymoustoken}`, false)
        xhttpImage.setRequestHeader("Access-Control-Allow-Origin", "*")
        try {
            xhttpImage.send()
            const ImageData = JSON.parse(xhttpImage.responseText)
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                this.setState({ [stateKey]: ImageData.data })
            }
        } catch (e) {
            PapiroConsole.log("e")
            PapiroConsole.log(e)
        }
    }

    getFileAttachment = async (attachment) => {
        const intl = this.props.intl
        this.setState({ loading: true })

        const url = await getFileDownloadLink(attachment.attachmentid)
        if (url && url.data && url.data.data && url.data.success) {
            this.setState({ loading: false })
            window.open(`${url.data.data}`, "_blank")
        } else {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: "Ocorreu um erro ao buscar o arquivo solicitado",
            })
        }
    }

    openCreateCalledDialog = (calledServiceSettingsList) => {
        this.setState({
            createCalledDialogOpen: true,
            calledServiceSettingsList: calledServiceSettingsList,
        })
    }

    closeCreateCalledDialog = () => {
        this.setState({ createCalledDialogOpen: false })
    }

    closeNotification = () => {
        this.setState({ openNotification: false })
    }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        this.setState({
            [name]: value,
        })
    }

    searchArticle = (searchValue) => {
        this.props.addCurrentSearch(searchValue, "text")
        this.props.history.push(`/${this.props.match.params.lang}/article-list-external`)
    }

    handleSelectedFaq = (id) => {
        const { filteredFaqs, selectedFaq } = this.state

        const allFaqs = filteredFaqs.reduce((acc, faq) => {
            if (faq.mapGroudFaqFromSubject && faq.mapGroudFaqFromSubject.length > 0) {
                return [...acc, ...faq.mapGroudFaqFromSubject]
            }
            return [...acc, faq]
        }, [])

        const newSelectedFaq = allFaqs.find((faq) => faq.id === id)

        const newFilteredFaqs = filteredFaqs.map((subject) => {
            if (newSelectedFaq.subject.id === subject.subjectId) {
                return { ...subject, open: true }
            } else {
                return { ...subject, open: false }
            }
        })

        if (newSelectedFaq && newSelectedFaq.id !== (selectedFaq && selectedFaq.id)) {
            this.setState({ selectedFaq: newSelectedFaq, filteredFaqs: newFilteredFaqs });
        }
    }

    render() {
        const { intl } = this.props
        const {
            loading,
            loadingFaqs,
            clientportal,
            logoimagesrc,
            mainimagesrc
        } = this.state

        if (!clientportal.enablefaq && !loading) {
            return (
                <Box
                    sx={{
                        minHeight: "100vh",
                        width: "100%",
                        backgroundColor: "#f8fafc",
                        display: "flex",
                        flexDirection: "column",
                        margin: 0,
                        padding: 0,
                        boxSizing: "border-box",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                    }}
                >

                    <Header
                        intl={this.props.intl}
                        clientportal={clientportal}
                        calledservicesettings={clientportal.calledservicesettingsclientportals}
                        language={this.props.match.params.lang}
                        openCreateCalledDialog={this.openCreateCalledDialog}
                        logoimagesrc={logoimagesrc}
                        loading={loading}
                    />

                    <Footer
                        intl={intl}
                        clientportal={clientportal}
                        setLoading={(loading) => this.setState({ loading: loading })}
                        loading={loading}
                    />

                    <CustomizedSnackbars
                        variant={this.state.notificationVariant}
                        message={this.state.notificationMessage}
                        isOpen={this.state.openNotification}
                        toClose={this.closeNotification}
                    />
                </Box>

            )
        }

        return (
            <Box
                ref={this.topRef}
                sx={{
                    minHeight: "100vh",
                    width: "100%",
                    backgroundColor: "#f8fafc",
                    display: "flex",
                    flexDirection: "column",
                    margin: 0,
                    padding: 0,
                    boxSizing: "border-box",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    overflow: "auto", // Garante que a rolagem aconteça dentro do Box e o fundo permaneça
                }}
            >
                <Header
                    intl={this.props.intl}
                    clientportal={clientportal}
                    calledservicesettings={clientportal.calledservicesettingsclientportals}
                    language={this.props.match.params.lang}
                    openCreateCalledDialog={this.openCreateCalledDialog}
                    logoimagesrc={logoimagesrc}
                    loading={loading}
                />

                <CommonSearchExternal
                    state={this.state}
                    clientportal={clientportal}
                    loading={loading}
                    mainImageSrc={mainimagesrc}
                    nameTextField={"searchValueBar"}
                    handleChange={this.handleChange}
                    searchArticle={this.searchArticle}
                />

                <FAQExternalClientMainContent
                    topRef={this.topRef}
                    state={this.state}
                    loading={loading}
                    loadingFaqs={loadingFaqs}

                    handleSearchChange={this.handleSearchChange}

                    onChangePaginate={this.onChangePaginate}
                    handleSelectedFaq={this.handleSelectedFaq}
                    getTagColor={this.getTagColor}
                    getFileAttachment={this.getFileAttachment}
                    handleSearch={this.handleSearch}
                    clearFaqs={this.clearFaqs}
                    handleClickOpenSubjectToFaqs={this.handleClickOpenSubjectToFaqs}
                    goToScrollTop={this.goToScrollTop}

                    addFilter={this.addFilter}
                    handleDelete={this.handleDelete}

                    AttachmentIcon={AttachmentIcon}
                />

                <Footer
                    intl={intl}
                    clientportal={clientportal}
                    setLoading={(loading) => this.setState({ loading: loading })}
                    loading={loading}
                />


                <CustomizedSnackbars
                    variant={this.state.notificationVariant}
                    message={this.state.notificationMessage}
                    isOpen={this.state.openNotification}
                    toClose={this.closeNotification}
                />

                <Modal
                    intl={intl}
                    title={<strong style={{ color: this.state.clientportal.defaulttextcolor }}>{this.state.clientportal.createcalledpagetitle || intl.formatMessage({ id: "choose.form" })}</strong>}
                    open={this.state.createCalledDialogOpen}
                    onClose={this.closeCreateCalledDialog}
                    contentPadding={false}
                    maxWidth="md"
                    children={
                        <CalledServicesSettingsExternalFormList
                            calledServiceSettingsList={this.state.calledServiceSettingsList}
                            clientportal={clientportal}
                        />
                    }
                />
            </Box>
        )
    }
}

FaqExternal.propTypes = (state) => ({
    classes: PropTypes.object.isRequired,
})

const mapStateToProps = (state) => ({
    classes: PropTypes.object.isRequired,
})

// const mapDispatchToProps = (dispatch) => bindActionCreators(articleActions, dispatch)

// export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(FaqExternal)))
// FaqExternal.contextType = AbilityContext


const mapDispatchToProps = dispatch =>
    bindActionCreators(articleActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(FaqExternal)));
FaqExternal.contextType = AbilityContext;